module.exports = __webpack_public_path__ + "img/8_newModelWorker_lyj.6ea45121.png";